import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quadpayMinAmountSelector } from '../../../checkout/selectors/order';

const QUADPAY_MERCHANT_ID = '15ce4178-c5a8-4b60-98ce-40e9c1422eb9';

function QuadpayWidget(props) {
  const {
    orderTotal, quadpayMinAmount, className, alignment = 'left',
  } = props;

  if (orderTotal < quadpayMinAmount) { return null; }

  return (
    <>
      <script src="https://cdn.us.zip.co/v1/quadpay.js" />
      <quadpay-widget-v3
        suppressHydrationWarning
        amount={orderTotal}
        class={className}
        alignment={alignment}
        merchantId={QUADPAY_MERCHANT_ID}
        logoSize="80%"
      />
    </>
  );
}

QuadpayWidget.propTypes = {
  orderTotal: PropTypes.number.isRequired,
  quadpayMinAmount: PropTypes.number.isRequired,
  className: PropTypes.string,
  alignment: PropTypes.string,
};

const mapStateToProps = (state) => ({
  quadpayMinAmount: quadpayMinAmountSelector(state),
});

export default connect(mapStateToProps)(QuadpayWidget);
